function gtagSafe() {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return null;
  return window.gtag.bind(window);
}

export function trackPageView(path) {
  const g = gtagSafe();
  if (!g) return;
  g('event', 'page_view', { page_path: path });
}

export function trackSignup(method = 'email') {
  const g = gtagSafe();
  if (!g) return;
  g('event', 'sign_up', { method });
}

export function trackWriteContent(type) {
  const g = gtagSafe();
  if (!g) return;
  g('event', 'write_post', { content_type: type });
}

export function trackChatStart(extra = {}) {
  const g = gtagSafe();
  if (!g) return;
  g('event', 'chat_start', { ...extra });
}

export function trackAdClick(adId, slot) {
  const g = gtagSafe();
  if (!g) return;
  g('event', 'ad_click', { ad_id: String(adId), slot: slot || 'feed' });
}
